import * as React from 'react';
import M from "materialize-css";
import { baseLogin } from '../Config/Config';
// import { redirect, useNavigate, useMatches, useParams } from 'react-router-dom';
import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';

export default function Email() {
  const [email, setEmail] = React.useState("");
  const navigate = useNavigate()

  const loginUser = () => {
    const headers = {
      'Content-Type': 'application/json',
      // [HTTP_USER_AGENT_HEADER]: 'HTTP_USER_AGENT',
    };

    axios.post(`${baseLogin}api/password_reset_custom/`, {
      "email": email
    }, { headers })
      .then((res) => {
        if (res.data===true){
          navigate("/reset-password-form")
        }
        else{
          M.toast({
            html: "Bunday email address topilmadi ",
            classes: "#00e676 red accent-3",
          });
        }

      })
      .catch((error) => {
        console.log(error)
        M.toast({
          html: "Bunday email address topilmadi ",
          classes: "#00e676 red accent-3",
        });

      });
  };
  return (
    <div className='email'>
      <div className='kirish'>
        <div className='box'>
          <form>
            <label >Email:</label>
            <input
              name="email"
              type="email"
              placeholder="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </form>
          <button className="btn" type="button" onClick={() => loginUser()}>
            jo'natish
          </button>
        </div>
      </div>
    </div>
  );
};
